export const InterceptorSkipHeader = 'X-Skip-Interceptor';
export const InterceptorSkipContentTypeHeader = 'X-Skip-Content-Type';
